export default "__VITE_ASSET__HqbdOm9K__"